import React from 'react'
import useHtmlClass from '../hooks/useHtmlClass'

const hasHtmlClass = WrappedComponent => props => {
    const [addHtmlClass, removeHtmlClass] = useHtmlClass()

    return <WrappedComponent
        addHtmlClass={addHtmlClass}
        removeHtmlClass={removeHtmlClass}
        {...props}
    />
}

export default hasHtmlClass